<template>
  <AMSConfigurator />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AMSConfigurator from './components/AMSConfigurator.vue';

export default defineComponent({
  name: 'App',
  components: {
    AMSConfigurator
  }
});
</script>


